import { u as useAuthContext, a as authStatus, b as AuthProvider, e as defaultState } from '../authContext-a01efdfb.js';
export { f as AuthenticationContext, S as StorageType, a as authStatus, u as useAuthContext } from '../authContext-a01efdfb.js';
import { b as __awaiter, c as __generator, _ as _assign, a as __rest } from '../tslib.es6-c6da0ae6.js';
import { jsx, Fragment } from 'react/jsx-runtime';
import HttpService from '@picsart/rc/services/http';
import useMount from '@picsart/rc/useMount';
import { useCallback, useEffect, forwardRef, useState, useImperativeHandle, useMemo, useRef } from 'react';
import useBearerAuthentication from '../useBearerAuthentication/index.js';
import { u as useAuth, a as useGoogleAuth } from '../useGoogleAuth-d54a1d14.js';
import { authorizationHeader, constructAuthHeaderValue } from '../services/auth/index.js';
import { API_URL, UNAUTHORIZED_STATUS_CODE, REFRESH_TOKEN_URL, RequestHeaders } from '../configs/constants/index.js';
import useHashParams from '../useHashParams/index.js';
import 'react-dom';
import { authStates, authStateKey } from '../models/user/index.js';
export { authStateKey, authStates } from '../models/user/index.js';
import { a as handleNewSocialRequest, s as signInTokenRequest } from '../requestFactory-4dc9ec32.js';
import '../isBrowser/index.js';
import '../services/errorLogger/index.js';
import '../services/logger/index.js';
import { c as SocialProviderOptions, h as AuthFlow } from '../constants-e3c79897.js';
import '@picsart/rc/services/analytics';
import { u as useRegistrationFormContext } from '../RegistrationFormContext-20b6a976.js';
import '../constants-8010f63c.js';
import { u as useStyles } from '../styles-59499c92.js';
import { setStorage } from '../services/browserStorage/index.js';

var useHandleFacebookAuthRedirecetion = function useHandleFacebookAuthRedirecetion(_a) {
  var _checkUser = _a.checkUser,
    triggeredFrom = _a.triggeredFrom,
    _b = _a.isAuthCombined,
    isAuthCombined = _b === void 0 ? false : _b;
  var hash = useHashParams();
  var accessToken = hash.get('access_token');
  var _c = useRegistrationFormContext(),
    setCurrentPage = _c.setCurrentPage,
    setSocialData = _c.setSocialData,
    setUsername = _c.setUsername,
    checkedStates = _c.checkedStates;
  var user = useAuthContext().user;
  var loginUser = useCallback(function (accessToken) {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setSocialData === null || setSocialData === void 0 ? void 0 : setSocialData({
              provider: SocialProviderOptions.facebook,
              credential: accessToken
            });
            return [4, handleNewSocialRequest({
              flow: AuthFlow.Default,
              credential: accessToken,
              provider: SocialProviderOptions.facebook,
              checkUser: function checkUser(user, removalInfo) {
                return _checkUser(SocialProviderOptions.facebook, user, removalInfo);
              },
              checkedStates: checkedStates,
              setCurrentPage: setCurrentPage,
              setUsername: setUsername,
              triggeredFrom: triggeredFrom,
              isAuthCombined: isAuthCombined
            })];
          case 1:
            _a.sent();
            return [2];
        }
      });
    });
  }, [setSocialData, checkedStates, setCurrentPage, setUsername, triggeredFrom, isAuthCombined, _checkUser]);
  useEffect(function () {
    if (!user && accessToken) {
      loginUser(accessToken);
    }
  }, [accessToken, loginUser, user]);
};

var internalBaseDomains = ['picsart.com', 'picsartstage.com', 'picsartstage2.com', 'aiavatar.com'];
var getHostname = function getHostname(url) {
  try {
    var urlObj = new URL(url);
    return urlObj.hostname;
  } catch (_a) {
    return window.location.hostname;
  }
};
var isInternalService = function isInternalService(urlToCheck) {
  var hostname = getHostname(urlToCheck);
  return urlToCheck.includes(API_URL) || internalBaseDomains.some(function (domain) {
    return hostname.endsWith(domain);
  });
};

function BearerAuthorization(_a, ref) {
  var _this = this;
  var children = _a.children,
    _b = _a.hideOneTap,
    hideOneTap = _b === void 0 ? false : _b,
    _c = _a.disableRefreshCycle,
    disableRefreshCycle = _c === void 0 ? false : _c,
    _d = _a.disableGoogleInit,
    disableGoogleInit = _d === void 0 ? false : _d,
    _e = _a.isSsr,
    isSsr = _e === void 0 ? false : _e;
  var tokenDataRef = useAuthContext().tokenDataRef;
  var _f = useBearerAuthentication(disableRefreshCycle),
    _makeLogout = _f.makeLogout,
    refreshTokenAndUser = _f.refreshTokenAndUser;
  var _g = useState(false),
    isBrowser = _g[0],
    setIsBrowser = _g[1];
  useImperativeHandle(ref, function () {
    return {
      makeLogout: function makeLogout() {
        _makeLogout();
      },
      refreshToken: refreshTokenAndUser
    };
  });
  useMount(function () {
    setIsBrowser(true);
    HttpService.registerInterceptor({
      request: function request(url, options) {
        var _a;
        return {
          url: url,
          options: _assign(_assign({}, options), {
            headers: _assign(_assign({}, options === null || options === void 0 ? void 0 : options.headers), authorizationHeader((_a = tokenDataRef === null || tokenDataRef === void 0 ? void 0 : tokenDataRef.current) === null || _a === void 0 ? void 0 : _a.access_token))
          })
        };
      }
    });
  });
  useMemo(function () {
    if (!isSsr || isBrowser) {
      var backupFetch_1 = window.fetch;
      var process_1 = {
        current: Promise.resolve({
          ok: true,
          status: 200
        })
      };
      var reinitializeRequestIfTokenIsRefreshed_1 = function reinitializeRequestIfTokenIsRefreshed_1(input, init) {
        return __awaiter(_this, void 0, void 0, function () {
          var isRequestObjectUsed, refreshTokenResponse, headers;
          var _a;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                isRequestObjectUsed = input instanceof Request;
                return [4, process_1.current];
              case 1:
                refreshTokenResponse = _b.sent();
                if (!refreshTokenResponse.ok && refreshTokenResponse.status === UNAUTHORIZED_STATUS_CODE && refreshTokenResponse.url.includes(REFRESH_TOKEN_URL)) return [2, backupFetch_1(input, init)];
                headers = new Headers(isRequestObjectUsed ? input.headers : init === null || init === void 0 ? void 0 : init.headers);
                if (headers.has(RequestHeaders.authorization)) {
                  headers.set(RequestHeaders.authorization, constructAuthHeaderValue((_a = tokenDataRef === null || tokenDataRef === void 0 ? void 0 : tokenDataRef.current) === null || _a === void 0 ? void 0 : _a.access_token));
                }
                return [2, isRequestObjectUsed ? backupFetch_1(new Request(input, {
                  headers: headers
                }), init) : backupFetch_1(input, _assign(_assign({}, init), {
                  headers: headers
                }))];
            }
          });
        });
      };
      window.fetch = function (input, init) {
        return __awaiter(_this, void 0, void 0, function () {
          var isRequestObjectUsed, url, actualRequest, result;
          var _a;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                if (!((_a = tokenDataRef === null || tokenDataRef === void 0 ? void 0 : tokenDataRef.current) === null || _a === void 0 ? void 0 : _a.access_token)) return [2, backupFetch_1(input, init)];
                isRequestObjectUsed = input instanceof Request;
                url = isRequestObjectUsed ? input.url : input.toString();
                if (!isInternalService(url)) return [2, backupFetch_1(input, init)];
                actualRequest = backupFetch_1(input, init);
                if (url.includes(REFRESH_TOKEN_URL)) {
                  process_1.current = actualRequest;
                }
                return [4, actualRequest];
              case 1:
                result = _b.sent();
                if (!(!result.ok && result.status === UNAUTHORIZED_STATUS_CODE && !result.url.includes(REFRESH_TOKEN_URL))) return [3, 3];
                return [4, refreshTokenAndUser()];
              case 2:
                _b.sent();
                return [2, reinitializeRequestIfTokenIsRefreshed_1(input, init)];
              case 3:
                return [2, result];
            }
          });
        });
      };
    }
  }, []);
  var _h = useAuth({
      triggeredFrom: 'navigation',
      authSuccessHandler: function authSuccessHandler() {}
    }),
    handleGoogleService = _h.handleGoogleService,
    checkUser = _h.checkUser;
  useGoogleAuth(function (data) {
    return handleGoogleService(data, false);
  }, null, null, null, hideOneTap, disableGoogleInit);
  useHandleFacebookAuthRedirecetion({
    checkUser: checkUser,
    triggeredFrom: 'navigation'
  });
  return jsx(Fragment, {
    children: children
  });
}
var BearerAuthorization$1 = /*#__PURE__*/forwardRef(BearerAuthorization);

function AuthProviderWrapper(_a) {
  var _this = this;
  var children = _a.children,
    disableRefreshCycle = _a.disableRefreshCycle,
    disableGoogleInit = _a.disableGoogleInit,
    props = __rest(_a, ["children", "disableRefreshCycle", "disableGoogleInit"]);
  var _b = useState(authStatus.pending),
    status = _b[0],
    setStatus = _b[1];
  var _c = useState(),
    tokenData = _c[0],
    setTokenData = _c[1];
  var _d = useState(null),
    user = _d[0],
    setUser = _d[1];
  useStyles();
  var authActionsRef = useRef(null);
  useEffect(function () {
    var _a;
    if (status === authStatus.resolved || status === authStatus.failed) {
      (_a = window === null || window === void 0 ? void 0 : window.pulse) === null || _a === void 0 ? void 0 : _a.call(window, 'state', {
        user_id: (user === null || user === void 0 ? void 0 : user.id) || null
      });
      setStorage(authStateKey, status === authStatus.resolved ? authStates.authorized : authStates.unauthorized);
      try {
        if (user && (window === null || window === void 0 ? void 0 : window.FS)) {
          window.FS('setIdentity', {
            uid: user === null || user === void 0 ? void 0 : user.id,
            properties: _assign({
              displayName: user.name,
              email: user.email
            }, user)
          });
        }
      } catch (e) {
        console.error(e);
      }
    }
  }, [status, user]);
  var handleSignInToken = useCallback(function (token) {
    return __awaiter(_this, void 0, void 0, function () {
      var user;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, signInTokenRequest(token)];
          case 1:
            user = _a.sent();
            setTokenData(user.token);
            setStatus(authStatus.resolved);
            setStorage(authStateKey, authStates.authorized);
            setUser(user);
            return [2, user];
        }
      });
    });
  }, []);
  var safeRefreshToken = useCallback(function () {
    var _a;
    if ((_a = authActionsRef.current) === null || _a === void 0 ? void 0 : _a.refreshToken) {
      return authActionsRef.current.refreshToken();
    }
    return Promise.reject(new Error('refreshToken is not available yet'));
  }, []);
  return jsx(AuthProvider, _assign({}, defaultState, {
    tokenData: tokenData,
    onTokenChange: setTokenData,
    status: status,
    handleSignInToken: handleSignInToken,
    onStatusChange: setStatus,
    user: user || null,
    onUserChange: setUser,
    makeLogout: function makeLogout() {
      var _a;
      return (_a = authActionsRef.current) === null || _a === void 0 ? void 0 : _a.makeLogout();
    }
  }, props, {
    refreshToken: safeRefreshToken
  }, {
    children: jsx(BearerAuthorization$1, _assign({
      ref: authActionsRef,
      hideOneTap: props === null || props === void 0 ? void 0 : props.hideOneTap,
      disableRefreshCycle: disableRefreshCycle,
      disableGoogleInit: disableGoogleInit,
      isSsr: props === null || props === void 0 ? void 0 : props.isSsr
    }, {
      children: children
    }))
  }));
}

export { AuthProviderWrapper as AuthProvider, BearerAuthorization$1 as BearerAuthorization };
//# sourceMappingURL=index.js.map
